export const searchRegex = /[^a-zA-Zа-яА-ЯііІїЇёЁъЪЫыєЄґҐ0-9.,' !№@#$%^&*()_\-+]/g;
